<template>
    <div>
        <div class="row mr-2">
            <div class="h1 my-2 col-11">分類管理</div>
            <button class="btn btn-primary mt-4 col-1" v-on:click="addclass">建立新的分類</button>
        </div>
        <table class="table mt-4">
            <thead>
                <tr>
                    <th>分類名稱</th>
                    <th width="15%">編輯</th>
                    <th width="15%">狀態</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in clas" :key="index">
                    <td :value="item.id">{{ item.name }}</td>
                    <td>
                        <button class="btn btn-outline-primary btn-sm" v-on:click="edit(item.id)">編輯</button>
                        <button class="btn btn-outline-primary btn-sm" v-on:click="del(item.id, index)">刪除</button>
                    </td>
                    <td>
                        <label :for="item.id" style="width: 100%; height: 100%;">
                            <input type="checkbox" :id="item.id" v-on:click="changeState(item.id, item.state)"
                                :checked="item.state">
                            開啟
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">建立新的分類</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-on:submit="classub">
                        <form enctype="multipart/form-data">
                            <div class="form-group">
                                <label for="formGroupExampleInput">分類名稱</label>
                                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="分類名稱"
                                    v-model="name" required pattern="^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$"
                                    maxlength="40">
                                <span>不得有特殊字元、空格、以底線作為開頭與結尾，最長不得超過40字元</span>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlSelect1">所屬分類</label>
                                <select class="form-control" id="exampleFormControlSelect1" v-model="parent_id">
                                    <!-- <option value="" disabled selected hidden>所屬分類</option> -->
                                    <option value="0">Root</option>
                                    <option v-for="item in clas" :key="item.id" :value="item.id">{{ item.fullname }}
                                    </option>
                                </select>
                            </div>
                            <!-- <div class="form-group">
                                <p>Image</p>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="product-image-real" ref="inputFile"
                                        @change="fileChange">
                                    <label class="custom-file-label" ref="newProductImage" for="product-image-real">
                                        Choose file
                                    </label>
                                </div>
                            </div> -->
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                                <button type="submit" class="btn btn-primary">確定</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog"
            aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">編輯分類</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label for="formGroupExampleInput">分類名稱</label>
                                <input type="text" class="form-control" id="formGroupExampleInput" placeholder="分類名稱"
                                    v-model="name" pattern="^(?!_)(?!.*?_$)[a-zA-Z0-9_\u4e00-\u9fa5]+$" maxlength="40">
                                <span>不得有特殊字元、空格、以底線作為開頭與結尾，最長不得超過40字元</span>
                            </div>
                            <div class="form-group">
                                <label for="exampleFormControlSelect1">所屬分類</label>
                                <select class="form-control" id="exampleFormControlSelect1" v-model="parent_id">
                                    <option value="0">Root</option>
                                    <option v-for="item in clas" :key="item.id" :value="item.id">{{ item.fullname }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group" v-if="this.image">
                                <p>分類圖片</p>
                                <img :src="base_url + '/uploads/' + this.image" alt="" class=""
                                    style="background-repeat: no-repeat; background-position: center; height: 70px;">
                            </div>
                            <div class="form-group">
                                <p>上傳圖片</p>
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="product-image-real" ref="inputFile"
                                        @change="fileChange">
                                    <label class="custom-file-label" ref="productImage" for="product-image-real">
                                        Choose file
                                    </label>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                                <button type="submit" class="btn btn-primary" v-on:click="classub2">確定</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            name: '',
            clas: [],
            parent_id: '',
            id: '',
            image: null,
            state: '',
            base_url,
        }
    },
    methods: {
        classub: function () {
            axios
                .post(base_url + '/admin/api/categories', {
                    name: this.name,
                    parent_id: this.parent_id
                })
                .then((response) => {
                    this.parent_id = response.data;
                    this.uploadImage(response.data.id);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        addclass: function () {
            this.id = "";
            this.name = "";
            this.parent_id = "";
            this.image = null;
            $("#exampleModalCenter").modal('show');
        },
        getcategory: function () {
            axios.get(base_url + '/admin/api/categories')
                .then((response) => {
                    this.clas = response.data;
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        edit: function (id) {
            axios.get(base_url + '/admin/api/categories/' + id)
                .then((response) => {
                    this.id = response.data.id;
                    this.name = response.data.name;
                    this.parent_id = response.data.parent_id;
                    this.image = response.data.image;
                })
                .catch(function (error) {
                    console.log(error);
                })
            $("#exampleModalCenter2").modal('show');
        },
        classub2: function () {
            axios
                .patch(base_url + '/admin/api/categories/' + this.id, {
                    name: this.name,
                    parent_id: this.parent_id,
                })
                .then((response) => {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        del: function (id, index) {
            axios.delete(base_url + '/admin/api/categories/' + id)
                .then((response) => {
                    this.clas.splice(index, 1);
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        changeState: function (id, state) {
            console.log(!state);
            axios.patch(base_url + '/admin/api/categories/' + id, {
                state: !state,
            })
                .then((response) => {

                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        fileChange(e) {
            var default_text = 'Choose file';
            if (e) {
                this.image = e.target.value ? e.target.files[0] : null;
                console.log(e.target.value);
                if (this.id) {
                    this.$refs.productImage.innerHTML = e.target.value ? e.target.value : default_text;
                    this.uploadImage(this.id);
                } else {
                    this.$refs.newProductImage.innerHTML = e.target.value ? e.target.value : default_text;
                }
                return;
            }
        },
        uploadImage(id) {
            let image = new FormData();
            image.append('image', this.image);
            image.append('_method', 'patch')
            let config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
            axios
                .post(
                    base_url + '/admin/api/categories/' + id,
                    image,
                    config
                )
                .then((response) => {
                    this.id = response.data.id;
                    this.name = response.data.name;
                    this.parent_id = response.data.parent_id;
                    this.image = response.data.image;
                })
                .catch(function (error) {
                    console.log(error);
                })
        }
    },
    created() {
        this.getcategory();
    },
}
</script>
